module.exports = __webpack_public_path__ + "img/11.5c812318.png";